export const normalizeLocale = (locale: string = '') =>
  locale?.replace('_', '-')
